// extracted by mini-css-extract-plugin
module.exports = {"replyButton":"_29dEW","reply":"_36_jm","replyIcon":"_2OYuD"};